/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Imagedeletedsuccessfully2Inputs */

const en_imagedeletedsuccessfully2 = /** @type {(inputs: Imagedeletedsuccessfully2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image deleted successfully`)
};

const de_imagedeletedsuccessfully2 = /** @type {(inputs: Imagedeletedsuccessfully2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bild gelöscht`)
};

/**
* | output |
* | --- |
* | "Image deleted successfully" |
*
* @param {Imagedeletedsuccessfully2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const imagedeletedsuccessfully2 = /** @type {((inputs?: Imagedeletedsuccessfully2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Imagedeletedsuccessfully2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_imagedeletedsuccessfully2(inputs)
	return de_imagedeletedsuccessfully2(inputs)
});
export { imagedeletedsuccessfully2 as "imageDeletedSuccessfully" }